// extracted by mini-css-extract-plugin
module.exports = {"container":"container--f2plu","textContent":"textContent--f2plu","button":"button--f2plu"};